import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GtmDirective } from 'src/app/shared/directives/gtm/gtm.directive';
import { DashboardRefreshModalData, KanbanBoardStore } from '@store';

@Component({
  selector: 'app-refresh-board-modal',
  standalone: true,
  imports: [CommonModule, GtmDirective, TranslateModule, MatCardModule, MatButtonModule],
  templateUrl: './refresh-board-modal.component.html',
  styleUrls: ['./refresh-board-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefreshBoardModalComponent {
  constructor(
    private dialogRef: MatDialogRef<RefreshBoardModalComponent, void>,
    private kanbanBoardStore: KanbanBoardStore,
    @Inject(MAT_DIALOG_DATA) private modalData: DashboardRefreshModalData
  ) {}

  refreshData(): void {
    if (this.modalData.listView) {
      this.kanbanBoardStore.refreshSnapshotInInstallationList();
    } else {
      this.kanbanBoardStore.fetchDashboard();
    }
    this.kanbanBoardStore.forceQuickViewClose$.next();
    this.dialogRef.close();
  }
}
